import i18n from '~/modules/i18n';

function shouldTranslate(text: string): boolean {
  return /^[A-Z0-9_\.]+$/.test(text);
}

function useTranslator() {
  const { t } = i18n.global;
  let output: string;

  function translate(text: string): string {
    if (shouldTranslate(text)) output = t(text);
    else output = text;

    return output;
  }

  return translate;
}

export default useTranslator();
